export function parseBudgetAmount(value: string) {
  return Number(value.replace(/[^0-9.]/g, "")) || 0;
}

export function parseDate(value: string) {
  if (!value) {
    return null;
  }

  let parsed: Date;

  if (value.includes("-")) {
    const [year, month, day] = value.split("-");
    if (!day || !month || !year) {
      return null;
    }

    parsed = new Date(Number(year), Number(month) - 1, Number(day));
  } else {
    const [day, month, year] = value.split("/");
    if (!day || !month || !year) {
      return null;
    }

    parsed = new Date(Number(year), Number(month) - 1, Number(day));
  }

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getCampaignDays(start: string, end: string) {
  const startDate = parseDate(start);
  const endDate = parseDate(end);

  if (!startDate || !endDate || endDate < startDate) {
    return null;
  }

  const diffMs = endDate.getTime() - startDate.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;
}

export function formatCurrency(value: string) {
  const amount = parseBudgetAmount(value);
  if (amount <= 0) {
    return "$0";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function getEstimatedImpressionsK(budgetAmount: number) {
  return budgetAmount > 0 ? `~${Math.round(budgetAmount * 147)}K` : "~0K";
}

export function getEstimatedAddToCarts(budgetAmount: number) {
  return budgetAmount > 0 ? `~${Math.round(budgetAmount * 1.72)}` : "~0";
}

export function getDailyBudget(
  budgetAmount: number,
  campaignDays: number | null,
) {
  return budgetAmount > 0 && campaignDays
    ? Math.round(budgetAmount / campaignDays)
    : 0;
}

export function getBudgetSummary(values: {
  totalBudget: string;
  budgetStartDate: string;
  budgetEndDate: string;
}) {
  const budgetAmount = parseBudgetAmount(values.totalBudget);
  const formattedBudget = formatCurrency(values.totalBudget);
  const campaignDays = getCampaignDays(
    values.budgetStartDate,
    values.budgetEndDate,
  );
  const dailyBudget = getDailyBudget(budgetAmount, campaignDays);

  return {
    budgetAmount,
    formattedBudget,
    campaignDays,
    dailyBudget,
    estimatedImpressions: getEstimatedImpressionsK(budgetAmount),
    estimatedAddToCarts: getEstimatedAddToCarts(budgetAmount),
  };
}
